import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { TESTIMONIALS } from "@/data/content";
import BrandMarkWatermark from "@/components/BrandMarkWatermark";

export default function Testimonials() {
  const { t, lang } = useLang();
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((v) => (v + 1) % TESTIMONIALS.length), 7000);
    return () => clearInterval(id);
  }, []);

  const current = TESTIMONIALS[idx];

  return (
    <section
      id="testimonials"
      className="relative overflow-hidden section-y bg-[color:var(--alabaster)]"
      data-testid="testimonials-section"
    >
      <BrandMarkWatermark size={640} opacity={0.10} style={{ bottom: -60, right: -80, zIndex: 1 }} />
      <div className="container-lux">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="overline" data-testid="testimonials-overline">{t.testimonials.overline}</div>
            <h2
              className="mt-6 font-serif-display text-[clamp(2rem,3.6vw,3rem)] leading-[1.05] tracking-[-0.01em] text-[color:var(--anthracite)]"
              data-testid="testimonials-title"
            >
              {t.testimonials.title}
            </h2>

            <div className="mt-10 flex items-center gap-2">
              {TESTIMONIALS.map((t, i) => (
                <button
                  key={t.id}
                  onClick={() => setIdx(i)}
                  className={`h-[2px] transition-all duration-500 ${i === idx ? "w-10 bg-[color:var(--copper)]" : "w-5 bg-[color:var(--anthracite)]/20"}`}
                  aria-label={`Show testimonial ${i + 1}`}
                  data-testid={`testimonial-dot-${i}`}
                />
              ))}
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="relative">
              <div
                className="font-serif-display text-[120px] leading-none text-[color:var(--copper)]/25 absolute -top-6 -start-4 select-none"
                aria-hidden
              >
                “
              </div>

              <div key={current.id} className="animate-fade-up relative" data-testid={`testimonial-${current.id}`}>
                <p className="font-serif-display text-[clamp(1.5rem,2.5vw,2.25rem)] leading-[1.35] text-[color:var(--anthracite)]">
                  {current.quote[lang] || current.quote.en}
                </p>

                <div className="mt-10 flex items-center gap-4">
                  <div className="h-px flex-none w-10 bg-[color:var(--copper)]" />
                  <div>
                    <div className="font-serif-display text-[18px] text-[color:var(--anthracite)]">
                      {current.author}
                    </div>
                    <div className="text-[11px] uppercase tracking-[0.22em] text-[color:var(--anthracite)]/55 mt-1">
                      {current.role[lang] || current.role.en}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
